<div id="title--container">
  <h4>Organisations</h4>
  <h5>{{ laboratory?.laboratoryName }}</h5>
</div>
<hr />
<div id="org--container">
  @if ((!organisations || organisations?.length === 0) && !isFirstLoad) {
    <div id="add-org--container">
      <app-icon-button
        label="add new organisation"
        buttonStyle="secondary"
        buttonId="create-org-btn"
        iconName="add_circle"
        buttonShape="square"
        (buttonClicked)="onCreateNewOrgansation()"
      ></app-icon-button>
    </div>
    <app-error-page primaryText="No organisations found"></app-error-page>
  }
  @if (isFirstLoad) {
    <div id="loading-spinner">
      <app-loading-spinner label="Fetching organisations"></app-loading-spinner>
    </div>
  }
  @if (organisations?.length > 0) {
    <div id="inner-page--container">
      <div id="stats-actions">
        <div id="left">
          <app-reduced-small-data-card
            title="Devices Currently Online"
            [dataReading]="devicesOnline"
          ></app-reduced-small-data-card>
          <app-reduced-small-data-card
            title="Devices Online in Last 24 Hours"
            [dataReading]="devicesOnlineLast24Hours"
          ></app-reduced-small-data-card>
          <app-reduced-small-data-card
            title="Active Experiments"
            [dataReading]="activeExperiments"
          ></app-reduced-small-data-card>
        </div>
        <div id="right">
          <app-search-field
            [field]="searchField"
            [parentForm]="orgTableControls"
            (buttonClicked)="handleSearch($event)"
          >
          </app-search-field>
          <app-mat-outlined-button
            label="Update Banner"
            ariaLabel="Update Banner"
            buttonId="update-banner-btn"
            (buttonClicked)="openModal('info-banner')"
          >
          </app-mat-outlined-button>
          <app-icon-button
            label="add new organisation"
            buttonStyle="secondary"
            buttonId="create-org-btn"
            iconName="add_circle"
            buttonShape="square"
            (buttonClicked)="onCreateNewOrgansation()"
          ></app-icon-button>
        </div>
      </div>
      <div id="table--container">
        <table mat-table [dataSource]="organisations">
          <caption class="sr-only">
            Organisation table
          </caption>

          <ng-container matColumnDef="name">
            <th
              mat-header-cell
              *matHeaderCellDef
              (click)="onSort('Name')"
              (keydown.enter)="onSort('Name')"
              (keydown.space)="$event.preventDefault(); onSort('Name')"
              [class.active]="currentSort.sortBy === 'Name'"
              [attr.aria-sort]="getAriaSort('Name')"
              tabindex="0"
            >
              <span class="sortable">
                Name
                <span class="sort-icons" aria-hidden="true">
                  <mat-icon>arrow_drop_up</mat-icon>
                  <mat-icon>arrow_drop_down</mat-icon>
                </span>
              </span>
            </th>
            <td mat-cell *matCellDef="let org">{{ org.organisationName }}</td>
          </ng-container>

          <ng-container matColumnDef="licenseType">
            <th
              mat-header-cell
              *matHeaderCellDef
              (click)="onSort('LicenseType')"
              (keydown.enter)="onSort('LicenseType')"
              (keydown.space)="$event.preventDefault(); onSort('LicenseType')"
              [class.active]="currentSort.sortBy === 'LicenseType'"
              [attr.aria-sort]="getAriaSort('LicenseType')"
              tabindex="0"
            >
              <span class="sortable">
                License Type
                <span class="sort-icons" aria-hidden="true">
                  <mat-icon>arrow_drop_up</mat-icon>
                  <mat-icon>arrow_drop_down</mat-icon>
                </span>
              </span>
            </th>
            <td mat-cell *matCellDef="let org">{{ LicenseDisplay[org.licenseType] }}</td>
          </ng-container>

          <ng-container matColumnDef="twoFactor">
            <th mat-header-cell *matHeaderCellDef>2FA Enabled</th>
            <td mat-cell *matCellDef="let org">
              <div class="icon">
                @if (org.requiresTwoFactor) {
                  <mat-icon class="positive" aria-hidden="true">check</mat-icon>
                } @else {
                  <mat-icon class="error" aria-hidden="true">close</mat-icon>
                }
                <span class="sr-only">{{ org.requiresTwoFactor ? 'Yes' : 'No' }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="users">
            <th mat-header-cell *matHeaderCellDef>Users</th>
            <td mat-cell *matCellDef="let org">{{ org.numberOfUsers }}</td>
          </ng-container>

          <ng-container matColumnDef="superUser">
            <th mat-header-cell *matHeaderCellDef>Super User</th>
            <td mat-cell *matCellDef="let org">
              {{ org.superUser?.superUserEmail }} <br />
              Invite accepted: {{ org.superUser?.inviteAccepted ? "Yes" : "No" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="devices">
            <th mat-header-cell *matHeaderCellDef>Devices Online/Total</th>
            <td mat-cell *matCellDef="let org">
              <span [class.muted]="org.numberOfDevicesOnline === -1">
                {{
                  org.numberOfDevicesOnline === -1
                    ? "--"
                    : org.numberOfDevicesOnline
                }}
              </span>/{{ org.numberOfDevices }}
            </td>
          </ng-container>

          <ng-container matColumnDef="labs">
            <th mat-header-cell *matHeaderCellDef>Labs</th>
            <td mat-cell *matCellDef="let org">{{ org.labSummary?.length }}</td>
          </ng-container>

          <ng-container matColumnDef="errors">
            <th
              mat-header-cell
              *matHeaderCellDef
              (click)="onSort('Errors')"
              (keydown.enter)="onSort('Errors')"
              (keydown.space)="$event.preventDefault(); onSort('Errors')"
              [class.active]="currentSort.sortBy === 'Errors'"
              [attr.aria-sort]="getAriaSort('Errors')"
              tabindex="0"
            >
              <span class="sortable">
                Unviewed Device Errors
                <span class="sort-icons" aria-hidden="true">
                  <mat-icon>arrow_drop_up</mat-icon>
                  <mat-icon>arrow_drop_down</mat-icon>
                </span>
              </span>
            </th>
            <td
              mat-cell
              *matCellDef="let org"
              [class.device-errors]="(org.labSummary | sumErrorLogs) > 0"
            >
              {{ org.labSummary | sumErrorLogs }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let org" (click)="$event.stopPropagation()">
              <app-mat-outlined-button
                [buttonId]="'view-org-btn-' + org.id"
                iconName="arrow_forward"
                iconPosition="right"
                ariaLabel="View Organisation"
                label="View Organisation"
                (buttonClicked)="viewOrganisation(org)"
              ></app-mat-outlined-button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="selectable-row"
            tabindex="0"
            (click)="viewOrgDetails(row.id)"
            (keydown.enter)="viewOrgDetails(row.id)"
          ></tr>
        </table>
        <div id="pagination--container">
          <div class="filter--container">
            <label for="orgs-per-page">Organisations per page</label>
            <app-dropdown-form-field
              id="orgs-per-page"
              [field]="orgsPerPageField"
              [parentForm]="orgTableControls"
            >
            </app-dropdown-form-field>
          </div>
          <div id="pagination--controls">
            <app-icon-button
              iconName="chevron_left"
              buttonId="previous"
              (buttonClicked)="getPrevious()"
              [isDisabled]="!hasPrevious"
            ></app-icon-button>
            <span> {{ currentPage }} / {{ totalPages }} </span>
            <app-icon-button
              iconName="chevron_right"
              buttonId="next"
              (buttonClicked)="getNext()"
              [isDisabled]="!hasNext"
            ></app-icon-button>
          </div>
        </div>
      </div>
      @if (selectedOrganisation) {
        <div id="org-detail--container">
          <h6>{{ selectedOrganisation.organisationName }} Labs</h6>
          <div class="inner-labs--container subtitle1">
            <span>Lab Name</span>
            <span>Lab ID</span>
            <span>Unviewed Errors</span>
            <span>Total Device Errors</span>
            <span>View Lab</span>
          </div>
          @for (
            lab of selectedOrganisation.labSummary;
            track lab.laboratoryId
          ) {
            <div class="inner-labs--container title body1">
              <span>{{ lab.laboratoryName }}</span>
              <span>{{ lab.laboratoryId }}</span>
              <span>{{ lab.unviewedErrorLogCount ?? 0 }}</span>
              <span>{{ lab.totalErrorLogCount || "0" }}</span>
              <app-icon-button
                buttonId="view-lab-btn"
                buttonStyle="transparent--blue"
                buttonShape="square"
                iconName="arrow_forward"
                (buttonClicked)="onViewLab(lab)"
              ></app-icon-button>
            </div>
          }
        </div>
      } @else {
        <h5 id="select-org-message">Select an organisation to view labs</h5>
      }
    </div>
  }
</div>
<app-modal
  id="attention-lab"
  titleText="Attention"
  primaryText="You are about to view a laboratory in a different organisation. Press cancel to return to the page, or continue to view laboratory."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-lab-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-lab-button"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="attention-org"
  titleText="Attention"
  primaryText="You are about to view another organisation. Press cancel to return to the page, or continue to view organisation."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-org-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-org-button"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-info-banner-modal
  id="info-banner"
  primaryButtonText="Update"
  primaryButtonId="update-button"
  secondaryButtonText="Close"
  secondaryButtonId="close-button"
  [parentForm]="dashboardBannerForm"
  [displayInformationBanner]="displayInformationBannerField"
  [informationBanner]="informationBannerField"
  [informationBannerType]="informationBannerTypeField"
  [isProcessing]="isProcessing"
  [errorMessage]="updateInformationBannerError"
  [successMessage]="updateInformationBannerSuccessMessage"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-info-banner-modal>
